export const fontMapper = {
	Prompt: "https://fonts.googleapis.com/css2?family=Prompt:ital,wght@0,200;0,400;0,700;1,200;1,400;1,700&display=swap",
    Inter: "https://fonts.googleapis.com/css2?family=Inter:ital,wght@0,200;0,400;0,700;1,200;1,400;1,700&display=swap"
}